import React from 'react';
import { useDispatch } from 'react-redux';

import { PinnedToggle } from '@candu-ai/craft/ui';
import { setPaletteAppearence, usePaletteAppearence } from 'craft/state';
import { PaletteAppearance } from 'craft/state/menus/reducer';

export const ToggleAppearance = () => {
  const dispatch = useDispatch();
  const pinnedAppearance = usePaletteAppearence();

  const onTogglePinned = () =>
    dispatch(
      setPaletteAppearence(
        pinnedAppearance === PaletteAppearance.PINNED
          ? PaletteAppearance.COLLAPSED
          : PaletteAppearance.PINNED,
      ),
    );

  return <PinnedToggle pinnedAppearance={pinnedAppearance} onToggle={onTogglePinned} />;
};
